'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageUrl = exports.makeFriendlyUrl = exports.findPageByName = exports.getCurrentPageId = exports.orderPages = undefined;
var _speakingurl = require('speakingurl');
var _speakingurl2 = _interopRequireDefault(_speakingurl);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var orderPages = exports.orderPages = function orderPages(pages, pageOrder) {
  if (!pageOrder || Array.isArray(pageOrder) && pageOrder.length === 0) {
    return Object.keys(pages).map(function (key) {
      return pages[key];
    });
  }
  return pageOrder.map(function (key) {
    return pages[key];
  });
};
var urlMatchesPage = function urlMatchesPage(name, page) {
  return !!page.friendlyUrl && name === page.friendlyUrl || name === makeFriendlyUrl(page.name);
};
var nameMatchesPage = function nameMatchesPage(name, page) {
  var decodedName = void 0;
  try {
    decodedName = decodeURI(name);
  } catch (e) {
    decodedName = name;
  }
  return decodedName === page.name;
};
var getCurrentPageId = exports.getCurrentPageId = function getCurrentPageId(currentPageUrl, pages, pageOrder) {
  return findPageByName(currentPageUrl, pages) || orderPages(pages, pageOrder)[0].id;
};
var findPageByName = exports.findPageByName = function findPageByName(name, pages) {
  pages = Object.keys(pages).map(function (k) {
    return pages[k];
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var page = _step.value;
      if (urlMatchesPage(name, page)) return page.id;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;
  try {
    for (var _iterator2 = pages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _page = _step2.value;
      if (nameMatchesPage(name, _page)) return _page.id;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
  return null;
};
var makeFriendlyUrl = exports.makeFriendlyUrl = function makeFriendlyUrl(name) {
  return (0, _speakingurl2.default)(name, {
    maintainCase: true
  });
};
var getPageUrl = exports.getPageUrl = function getPageUrl(page) {
  return page.friendlyUrl || makeFriendlyUrl(page.name);
};